import React from 'react';
import { Modal } from '../../../../../components/Modal/Modal';
import { Payment } from '../../../../../core-module/services/payments/types';
import { PaymentsContainerDetails } from './PaymentsContainerDetails';

interface Props {
  show: boolean;
  payment: Payment;
  onClose: () => void;
}

const PaymentsDetailsModal: React.FC<Props> = ({ payment, show, onClose }) => {
  return (
    <Modal
      visible={show}
      title='Details'
      okText='Sluiten'
      onOk={onClose}
      onCancel={onClose}
    >
      <PaymentsContainerDetails payment={payment} />
    </Modal>
  );
};

export { PaymentsDetailsModal };
